<template>
  <div class="modal fade" id="commentModal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-left">
          <div class="review-details">
            <div class="spread-container">
              <span class="name secondary_title">
                {{ comment_item.name }}
                <span
                  class="country"
                  v-if="
                    (comment_item.country &&
                      comment_mode != 'page' &&
                      comment.comment_country == 'yes') ||
                    (comment_mode == 'page' &&
                      comment.store_comment_country == 'yes')
                  "
                >
                  <country-flag
                    v-if="comment_item && comment_item.country"
                    :country="comment_item.country=='UK'?'GB':comment_item.country"
                    size='small'
                  />
                  {{ comment_item.country }}
                </span>
              </span>
              <span
                  class="time"
                  v-if="
                    (comment_mode != 'page' && comment.comment_time == 'yes') ||
                    (comment_mode == 'page' &&
                      comment.store_comment_time == 'yes')
                  "
                >
                  {{ comment_item.comment_date }}
                </span>

            </div>
            <div class="spread-container">
              <v-comments-star
                :disabled="true"
                :average_rating="comment_item.rating - 0"
              ></v-comments-star>
            </div>
          </div>
          <div class="review-main">
            <p>{{ comment_item.content }}</p>
            <v-commentReply
              v-if="comment_item.reply && comment_item.reply.length"
              :reply="comment_item.reply"
              style="padding:0"
            ></v-commentReply>
          </div>
          <div
            class="product-details"
            v-if="comment_item && comment_item.products"
          >
            <v-product-info
              :procuts_info="comment_item.products"
            ></v-product-info>
            <div class="product-url">
              <a :href="comment_item.products.path" target="_blank">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M4.66667 5.33335V4.00002C4.66667 3.11597 5.01786 2.26812 5.64298 1.643C6.2681 1.01788 7.11595 0.666687 8 0.666687C8.88406 0.666687 9.7319 1.01788 10.357 1.643C10.9821 2.26812 11.3333 3.11597 11.3333 4.00002V5.33335H13.3333C13.5101 5.33335 13.6797 5.40359 13.8047 5.52862C13.9298 5.65364 14 5.82321 14 6.00002V14C14 14.1768 13.9298 14.3464 13.8047 14.4714C13.6797 14.5964 13.5101 14.6667 13.3333 14.6667H2.66667C2.48986 14.6667 2.32029 14.5964 2.19526 14.4714C2.07024 14.3464 2 14.1768 2 14V6.00002C2 5.82321 2.07024 5.65364 2.19526 5.52862C2.32029 5.40359 2.48986 5.33335 2.66667 5.33335H4.66667ZM4.66667 6.66669H3.33333V13.3334H12.6667V6.66669H11.3333V8.00002H10V6.66669H6V8.00002H4.66667V6.66669ZM6 5.33335H10V4.00002C10 3.46959 9.78929 2.96088 9.41421 2.58581C9.03914 2.21073 8.53043 2.00002 8 2.00002C7.46957 2.00002 6.96086 2.21073 6.58579 2.58581C6.21071 2.96088 6 3.46959 6 4.00002V5.33335Z"
                    fill="black"
                  ></path>
                </svg>
                {{$t('comment.view_product')}}
              </a>
            </div>
          </div>
        </div>
        <div class="modal-right">
          <button type="button" class="close" data-dismiss="modal" @click="() => $emit('close')">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 10.5862L16.95 5.63623L18.364 7.05023L13.414 12.0002L18.364 16.9502L16.95 18.3642L12 13.4142L7.04999 18.3642L5.63599 16.9502L10.586 12.0002L5.63599 7.05023L7.04999 5.63623L12 10.5862Z"
                fill="white"
              ></path>
            </svg>
          </button>
          <div
            class="review-gallery"
            v-if="
              comment_item &&
              comment_item.gallery &&
              comment_item.gallery.length
            "
          >
            <span
              class="arrow prev arrows-left"
              v-if="comment_item.gallery.length > 1"
              @click="current_page--"
            ></span>
            <span
              class="arrow next arrows-right"
              v-if="comment_item.gallery.length > 1"
              @click="current_page++"
            ></span>
            <span class="page-number" v-if="comment_item.gallery.length > 1">
              {{ current_page }} / {{ comment_item.gallery.length }}</span
            >
            <v-lazy-img :data-url="comment_item.gallery[current_page - 1].url"></v-lazy-img>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vProductInfo from "./productInfo";
import vCommentReply from "./commentReply.vue";
import vCommentsStar from './commentsstar.vue'

export default {
  props: ["comment_item","modal_index","comment_mode",
    "comment",],
  data() {
    return {
      current_page: 1,
    };
  },
  emits: ['close'],
  watch: {
    modal_index(newV){
      this.current_page=newV;
    },
    current_page(newV) {
      if (newV > this.comment_item.gallery.length) this.current_page = 1;
      else if (newV < 1) this.current_page = this.comment_item.gallery.length;
      this.$emit('change_modal_index',this.current_page);
    },
  },
  components: {
    vProductInfo,
    vCommentReply,
    vCommentsStar,
    CountryFlag: resolve => {require(['vue-country-flag'], resolve)},
  },
};
</script>
<style scoped lang='scss'>
#commentModal {
  .modal-dialog {
    border-radius: 10px;
    overflow: hidden;
    max-width: 813px !important;
    height: 65vh;
    min-height: 584px;
    margin-top: 100px;
    .modal-content {
      display: flex;
      flex-direction: row;
      height: 100%;
      border: none;
      .modal-left,
      .modal-right {
        width: 50%;
      }
      .modal-right {
        position: relative;
        background-color: #e7e6eb;
        .review-gallery {
          height: 100%;
          width: 100%;
          position: relative;
          .page-number {
            position: absolute;
            z-index: 2;
            font-size: 12px;
            bottom: 10px;
            left: 50%;
            pointer-events: none;
            transform: translateX(-50%);
          }
          .arrow {
            position: absolute;
            z-index: 2;
            top: 49%;
            width: 20px;
            height: 20px;
            cursor: pointer;
          }
          .prev {
            left: 10px;
          }
          .next {
            right: 10px;
          }
          img {
            width: 100%;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            max-width: 100% !important;
            max-height: 100% !important;
            object-fit: cover;
          }
        }
        .close {
          text-align: center;
          position: absolute;
          right: auto;
          z-index: 1;
          top: 16px;
          right: 16px;
          color: white;
          background-color: rgba(0, 0, 0, 0.3);
          padding: 6px;
          border-radius: 8px;
          transition: background-color 0.1s ease-in;
          outline: none;
        }
      }
      .modal-left {
        display: flex;
        flex-direction: column;
        background-color: white;
        .review-details {
          padding: 24px 24px 16px 24px;
          .spread-container {
            display: flex;
            justify-content: space-between;
            .name{
              text-align: left;
              margin: 0;
              padding: 0;
              -webkit-tap-highlight-color: transparent;
              font-size: 16px;
              color: #222;
              display: inline-block;
              vertical-align: middle;
              line-height: 22px;
              font-weight: bold;
            }
            .country{
              vertical-align: sub;
              font-family: NunitoSans-Regular !important;
               font-size: 14px;
            }
            .time{
              margin-top: 0;
              color: #999;
              font-size: 12px;
              font-family: NunitoSans-Regular !important;
            }

          }
        }
        .review-main {
          padding: 0 24px;
          flex: 1;
          overflow: auto;
          &>p{
            padding-bottom: 20px;
          }
        }
        .product-details {
          padding: 0 14px 24px;
          .product-url {
            text-align: center;
            a {
              display: inline-flex;
              padding: 6px 11px;
              background-color: rgba(0, 0, 0, 0.05);
              border-radius: 8px;
              text-decoration: none;
              color: #282828;
              line-height: 1;
              svg {
                margin-right: 10px;
              }
              &:hover {
                background-color: rgba(0, 0, 0, 0.1);
              }
            }
          }
        }
      }
    }
  }
}
@media screen and(max-width: 768px) {
  #commentModal {
    .modal-dialog {
      border-radius: 0;
      padding: 0;
      max-width: 100% !important;
      width: 100%;
      height: 100vh;
      margin: 0;
      overflow: unset;
      .modal-content {
        flex-direction: column;
        .modal-left,
        .modal-right {
          width: 100%;
        }
        .modal-right {
          min-height: 75vw;
          height: 75vw;
          max-height: 135vw;
          order: 1;
        }
        .modal-left {
          flex: 1;
          order: 2;
        }
      }
    }
  }
}
</style>
